// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type {
  KnowledgeBaseRetrievalContext,
  KnowledgeBaseRetrievalClientOptionalParams,
} from "./knowledgeBaseRetrievalContext.js";
export { createKnowledgeBaseRetrieval } from "./knowledgeBaseRetrievalContext.js";
export { retrieve } from "./operations.js";
export type { RetrieveOptionalParams } from "./options.js";
